import { ToggleButtons } from "@costar-search-x/components";
import { SearchViewMode, itemId } from "@costar-search-x/core";
import Link from "next/link";
import { CoStar } from "@costar-gen/pds-node-client";

export const emptyFn = () => {
  /* tslint:disable:no-empty */
};

export const HiddenButtonsSearchPage = [
  ToggleButtons.Filters,
  ToggleButtons.Reports,
  ToggleButtons.Save,
  ToggleButtons.Sort,
  ToggleButtons.Export,
];

export const initialViewModeState = {
  viewMode: SearchViewMode.ListView,
  searchKey: "",
  setViewMode: emptyFn,
  setSearchKey: emptyFn,
  isDetailViewMode: false,
  endDetailViewMode: emptyFn,
};

export type RowRenderable = { [itemId]: string; urlSlug?: string };

export const renderRowWithLink = (
  onClickUrl: (row: RowRenderable) => string,
  automationId?: string
) => {
  return function rowComponent(value: string, row: RowRenderable) {
    return (
      <Link
        href={onClickUrl(row)}
        className="w-full align-middle"
        automation-id={automationId}
      >
        {value}
      </Link>
    );
  };
};

const GeographyFilterType = CoStar.Api.Search.Criteria.GeographyFilterType;

export const supportedLocationTypes = [
  GeographyFilterType.City,
  GeographyFilterType.Submarket,
  GeographyFilterType.County,
  GeographyFilterType.Subdivision,
  GeographyFilterType.Country,
  GeographyFilterType.Region,
  GeographyFilterType.CoStarMarket,
  GeographyFilterType.PostalCodeGlobal,
];

export const LGWINDOWCUTOFF = 1024;

export const DEFAULT_PAGESIZE = 20;
